import React from 'react';
import {BtnSearchBtn} from "./style/ButtonStyle";



function BtnSearch({Listener, setPageable}) {

    const handler =()=>{
        // 검색 시 페이지 1번으로 이동
        setPageable((prevSearchObject) => ({
            ...prevSearchObject,
            page: 0
        }));
        Listener();
    }

    return (
        <BtnSearchBtn onClick={handler}>검색</BtnSearchBtn>
    );
}

export default BtnSearch;